export enum profitabilityUpdateTypes {
    BY_DELIVERY_SERVICE = 'BY_DELIVERY_SERVICE',
    BY_NUMBERS = 'BY_NUMBERS'
}